import { jsx as _jsx } from "react/jsx-runtime";
import { ConsentGuard } from './ConsentGuard';
import { EMBED_TYPES } from '../constants';
import { extractWebsite, getAspectRatioForEmbed, getProviderName, normalizeType, } from '../utils';
export const EmbedConsentGuard = ({ children, embed, isActive }) => {
    const aspectRatio = getAspectRatioForEmbed(embed);
    const type = normalizeType(embed.type);
    const shouldGuard = isActive && [EMBED_TYPES.VIDEO, EMBED_TYPES.RICH].includes(type);
    const hostName = extractWebsite(embed.provider_url || embed.url);
    const providerName = getProviderName(embed);
    return (_jsx(ConsentGuard, { aspectRatio: aspectRatio, hostName: hostName, isActive: shouldGuard, providerName: providerName, children: children }));
};
//# sourceMappingURL=EmbedConsentGuard.js.map